export default __webpack_public_path__ + "static/media/image 10.d9153ad2.png";